/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalMessagePage } from './PortalMessagePage';
import {
    PortalMessagePageFromJSON,
    PortalMessagePageFromJSONTyped,
    PortalMessagePageToJSON,
    PortalMessagePageToJSONTyped,
} from './PortalMessagePage';

/**
 * 
 * @export
 * @interface PortalMessagePageResponse
 */
export interface PortalMessagePageResponse {
    /**
     * 
     */
    data: PortalMessagePage;
}

/**
 * Check if a given object implements the PortalMessagePageResponse interface.
 */
export function instanceOfPortalMessagePageResponse(value: object): value is PortalMessagePageResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalMessagePageResponseFromJSON(json: any): PortalMessagePageResponse {
    return PortalMessagePageResponseFromJSONTyped(json, false);
}

export function PortalMessagePageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalMessagePageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalMessagePageFromJSON(json['data']),
    };
}

export function PortalMessagePageResponseToJSON(json: any): PortalMessagePageResponse {
    return PortalMessagePageResponseToJSONTyped(json, false);
}

export function PortalMessagePageResponseToJSONTyped(value?: PortalMessagePageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalMessagePageToJSON(value['data']),
    };
}

